<template>
  <div class="edit-report-variant-dailog dialog col-block">
    <div class="block-container variant col-block">
      <div class="title-container">
        <div
          class="title"
          v-html="{
            'ACMG': $t('DIALOG.editReportVariant.___acmgTitle'),
            'SIFT & Polyphen2': $t('DIALOG.editReportVariant.___siftPolyphen2Title')
          }[type]"
        ></div>
        <div :style="{ flex: 1 }"></div>
      </div>
      <div :style="{ height: '10px' }"></div>
      <div class="variant-container col-block flex-start">
        <div class="variant-title" v-html="'<b>' + (variant.SYMBOL || '- -') + '</b>' + ' ' + variant.CHROM + ':' + variant.POS + variant.REF + '>' + variant.ALT"></div>
      </div>
    </div>
    <div :style="{ height: '15px' }"></div>
    <template v-if="type === 'ACMG'">
      <div class="block-container form col-block">
        <div class="title-container">
          <div class="title" v-html="$t('DIALOG.editReportVariant.variantForm.title.___acmg')"></div>
          <div :style="{ flex: 1 }"></div>
        </div>
        <div :style="{ height: '12px' }"></div>
        <div class="form-container row-block">
          <div class="form-list-container row-block flex-wrap">
            <div class="form-item-container" v-for="(item, index) in formItems['ACMG']" :key="index">
              <div class="form-item row-block" @click="e => setValue('ACMG', item)">
                <img :class="{ multiple: multiple['ACMG'] }" :src="result['ACMG'].includes(item.value) ? require('../../assets/images/' + (multiple['ACMG'] ? 'checkbox': 'radio') + '-true.svg') : require('../../assets/images/' + (multiple['ACMG'] ? 'checkbox': 'radio') + '-false.svg')">
                <div :style="{ width: '8px' }"></div>
                <div class="chapter-title" :style="item.color ? { color: item.color } : {}">{{ item.title }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-if="type === 'SIFT & Polyphen2'">
      <div class="block-container form col-block">
        <div class="title-container">
          <div class="title" v-html="$t('DIALOG.editReportVariant.variantForm.title.___sift')"></div>
          <div :style="{ flex: 1 }"></div>
        </div>
        <div :style="{ height: '10px' }"></div>
        <div class="form-container row-block">
          <div class="form-list-container row-block flex-wrap">
            <div class="form-item-container" v-for="(item, index) in formItems['SIFT']" :key="index">
              <div class="form-item row-block" @click="e => setValue('SIFT', item)">
                <img :class="{ multiple: multiple['SIFT'] }" :src="result['SIFT'].includes(item.value) ? require('../../assets/images/' + (multiple['SIFT'] ? 'checkbox': 'radio') + '-true.svg') : require('../../assets/images/' + (multiple['SIFT'] ? 'checkbox': 'radio') + '-false.svg')">
                <div :style="{ width: '8px' }"></div>
                <div class="chapter-title" :style="item.color ? { color: item.color } : {}">{{ item.title }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="block-container form col-block">
        <div class="title-container">
          <div class="title" v-html="$t('DIALOG.editReportVariant.variantForm.title.___polyphen2')"></div>
          <div :style="{ flex: 1 }"></div>
        </div>
        <div :style="{ height: '10px' }"></div>
        <div class="form-container row-block">
          <div class="form-list-container row-block flex-wrap">
            <div class="form-item-container" v-for="(item, index) in formItems['Polyphen2']" :key="index">
              <div class="form-item row-block" @click="e => setValue('Polyphen2', item)">
                <img :class="{ multiple: multiple['Polyphen2'] }" :src="result['Polyphen2'].includes(item.value) ? require('../../assets/images/' + (multiple['Polyphen2'] ? 'checkbox': 'radio') + '-true.svg') : require('../../assets/images/' + (multiple['Polyphen2'] ? 'checkbox': 'radio') + '-false.svg')">
                <div :style="{ width: '8px' }"></div>
                <div class="chapter-title" :style="item.color ? { color: item.color } : {}">{{ item.title }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-if="type === 'Parental Origin'">
      <div class="block-container form col-block">
        <div class="title-container">
          <div class="title" v-html="$t('DIALOG.editReportVariant.variantForm.title.___parentalOrigin')"></div>
          <div :style="{ flex: 1 }"></div>
        </div>
        <div :style="{ height: '12px' }"></div>
        <div class="form-container row-block">
          <div class="form-list-container row-block flex-wrap">
            <div class="form-item-container" v-for="(item, index) in formItems['ParentalOrigin']" :key="index">
              <div class="form-item row-block" @click="e => setValue('ParentalOrigin', item)">
                <img :class="{ multiple: multiple['ParentalOrigin'] }" :src="result['ParentalOrigin'].includes(item.value) ? require('../../assets/images/' + (multiple['ParentalOrigin'] ? 'checkbox': 'radio') + '-true.svg') : require('../../assets/images/' + (multiple['ParentalOrigin'] ? 'checkbox': 'radio') + '-false.svg')">
                <div :style="{ width: '8px' }"></div>
                <div class="chapter-title" :style="item.color ? { color: item.color } : {}">{{ item.title }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <div :style="{ height: '15px' }"></div>
    <div class="button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="gray-button circle-button" @click="e => $emit('changeModal')">
        <span>{{ $t('COMMON.button.___cancel') }}</span>
      </button>
      <div :style="{ width: '20px' }"></div>
      <button class="main-button circle-button" @click="e => $emit('changeModal', {}, result)">
        <span>{{ $t('COMMON.button.___update') }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import { reportParentalOriginMap, predictionMetaDatas, defaultEmptyDisplay } from '../../constants/global/data'

export default {
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      result: {
        'ACMG': [],
        'SIFT': [],
        'Polyphen2': [],
        'ParentalOrigin': []
      },
      multiple: {
        'ACMG': false,
        'SIFT': false,
        'Polyphen2': false,
        'ParentalOrigin': false
      }
    }
  },
  created () {
    this.result = {
      ...this.result,
      ...this.param.value
    }
    this.multiple = {
      ...this.multiple,
      ...this.param.multiple
    }
  },
  computed: {
    formItems () {
      return {
        'ACMG': [
          { title: 'Pathogenic', value: 'Pathogenic', color: '#FA3D3D' },
          { title: 'Likely pathogenic', value: 'Likely pathogenic', color: '#FF9E03' },
          { title: 'Uncertain significance', value: 'Uncertain significance' },
          { title: 'Likely benign', value: 'Likely benign' },
          { title: 'Benign', value: 'Benign' }
        ],
        'SIFT': [
          ...Object.entries(predictionMetaDatas['SIFT4G'].displayMap).map(([value, title]) => ({
            ...{ title: this.$t(title), value: value },
            ...((predictionMetaDatas['SIFT4G'].checkPassed || (() => true))(null, value) ? {} : { color: '#FA3D3D' })
          })),
          { title: this.$t(defaultEmptyDisplay.empty), value: 'N/A' }
        ],
        'Polyphen2': [
          ...Object.entries(predictionMetaDatas['Polyphen'].displayMap).map(([value, title]) => ({
            ...{ title: this.$t(title), value: value },
            ...((predictionMetaDatas['Polyphen'].checkPassed || (() => true))(null, value) ? {} : { color: '#FA3D3D' })
          })),
          { title: this.$t(defaultEmptyDisplay.empty), value: 'N/A' }
        ],
        'ParentalOrigin': Object.entries(reportParentalOriginMap).map(([value, title]) => ({ title: title, value: value }))
      }
    },
    // param
    type () {
      return this.param.type
    },
    variant () {
      return this.param.variant
    }
  },
  methods: {
    setValue (type, item) {
      if (!this.multiple[type]) {
        this.result[type] = []
      }
      this.result[type] = !this.result[type].includes(item.value) ? this.result[type].concat([item.value]) : this.result[type].length > 1 ? this.result[type].filter(value => value !== item.value) : this.result[type]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/editReportVariant.vue